import { Badge } from '../../../components/ui/badge';

export function SemaforoBadge({ color, size = 'md' }) {
  const map = {
    verde:    { bg: 'bg-emerald-500',  ring: 'ring-emerald-200',  text: 'OK' },
    amarillo: { bg: 'bg-amber-500',    ring: 'ring-amber-200',    text: 'Revisar' },
    rojo:     { bg: 'bg-red-600',      ring: 'ring-red-200',      text: 'Bloquear' },
    gris:     { bg: 'bg-slate-400',    ring: 'ring-slate-200',    text: 'Reenviado' },
  };
  const c = map[color] || map.amarillo;
  const dot = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3.5 h-3.5';
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`${dot} rounded-full ${c.bg} ring-2 ${c.ring}`} />
      <span className="text-xs font-medium">{c.text}</span>
    </span>
  );
}

export function EstadoMatchBadge({ estado }) {
  const map = {
    match_perfecto:           { label: 'OK',                cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
    match_parcial:            { label: 'Parcial',           cls: 'bg-amber-100  text-amber-800  border-amber-300' },
    faltante:                 { label: 'Faltante',          cls: 'bg-red-100    text-red-800    border-red-300' },
    ya_pagada:                { label: 'Ya pagada',         cls: 'bg-slate-100  text-slate-700  border-slate-300' },
    en_rcv_pendiente_contab:  { label: 'En RCV (sin contab.)', cls: 'bg-indigo-100 text-indigo-800 border-indigo-300' },
  };
  const c = map[estado] || map.match_parcial;
  return <Badge variant="outline" className={`${c.cls} text-xs`}>{c.label}</Badge>;
}
